__turbopack_context__.v({
  "container": "ReviewScore-module-scss-module__UK1cJq__container",
  "star": "ReviewScore-module-scss-module__UK1cJq__star",
});
